export const PHOTO_GALLERY_ACTIONS = {
  SET_STATE: "photoGallery/setState",
  GET_PHOTO_GALLERY: "photoGallery/getPhotoGallery",
  GET_PHOTO_GALLERY_BY_ID: "photoGallery/getPhotoGalleryById",
  CREATE_PHOTO_GALLERY: "photoGallery/createPhotoGallery",
  UPDATE_PHOTO_GALLERY: "photoGallery/updatePhotoGallery",
  DELETE_PHOTO_GALLERY: "photoGallery/deletePhotoGallery",
};
